import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    poolName: 'Pool name',
    withdrawalAmount: 'Withdrawal amount',
    initiated: 'Initiated',
    unlockTime: 'Time until unlock',
  },
};
